<template>
	<div id="app" class="cont">
		<div class="login-wrap">
			<div class="logo-box">云喵圈子</div>
			<el-form ref="form" :model="form">
				<el-form-item>
					<el-input class="login-input" prefix-icon="el-icon-user-solid" v-model="form.username" placeholder="请输入用户名"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input class="login-input" prefix-icon="el-icon-unlock" type="password" v-model="pwd" placeholder="请输入密码"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button class="btn-submit" type="primary" @click="login">登录</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="powered">Powered by 云喵圈子</div>
	</div>
</template>

<script>
	import md5 from 'js-md5';
	export default {
		data() {
			return {
				form: {
					username: '',
					password: "",
				},
				pwd: ""
			}
		},
		methods: {
			login() {
				let that = this;
				this.form.password = md5(this.pwd);
				this.$H.post("user/adminLogin", this.form).then(res => {
					if (res.code == 200) {
						this.$message({
							message: '登录成功',
							type: 'success'
						});

						this.$store.commit('setUserInfo', res.result);
						setTimeout(function() {
							that.$router.push('/');
						}, 2000)
					}

				})
			}
		}
	}
</script>
<style>
	.login-input .el-input__inner{
		margin-left: 10px;
		border: 0 !important;
	}
</style>
<style scoped="scoped">
	body {
		background-color: #f5f5f5;
		padding: 0;
		margin: 0;
	}

	.cont {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100vw;
		height: 100vh;
	}

	.logo {
		margin-bottom: 50px;
	}

	.login-wrap {
		width: 350px;
		padding: 40px;
		background-color: #fff;
		border-radius: 4px;
		box-shadow: 0 0 12PX 0 rgba(88, 88, 90, .21);
	}

	.el-input {
		border-bottom: 1px solid #e3e3e3 !important;
	}


	.el-input__icon {
		font-size: 20px;
	}

	.btn-submit {
		margin-top: 50px;
		width: 100%;
	}

	.powered {
		text-align: center;
		font-size: 14px;
		color: #999;
		margin-top: 80px;
	}

	.logo-box {
		font-size: 40px;
		font-weight: bold;
		text-align: center;
		margin-bottom: 50px;
	}
</style>
